import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'

export class DynamicStaticImage extends React.PureComponent<DynamicStaticImage.Props, DynamicStaticImage.State> {
  public static sectionId = 'statici'

  public render(): JSX.Element {
    const { settings } = this.props.section
    if (!settings) return null
    const image = window.innerWidth > 1024 ? settings.image : settings.imagemobile
    const ratio = window.innerWidth > 1024 || settings.keepdesktopratio ? '16:9' : '11:20'
    const margins = settings.maxwidth === 'Align with Footer' ? 'mx-1-6 sm:mx-2-4 xl:mx-22 md:mx-2-8' : undefined
    const maxWidth = settings.maxwidth !== 'Full' && settings.maxwidth !== 'Align with Footer' ? settings.maxwidth : undefined

    return (
      <section className={'dynamic-video'}>
        <div style={{ maxWidth }} className={`${maxWidth != undefined ? 'max-w-container' : ''} ${margins || 'mx-auto'} relative`}>
          {image ? <Snippets.Image
            alt={'Image'}
            ratio={ratio}
            className={'absolute inset-0 w-full'}
            src={image}
            preventLazy
          /> : null}
        </div>
      </section>
    )
  }
}

export namespace DynamicStaticImage {
  export type Options = ShopifyNext.Section<{
    image: string;
    imagemobile: string;
    maxwidth: string;
    keepdesktopratio: boolean;
  }>;
  export interface Props extends GlobalProps {
    section: DynamicStaticImage.Options;
  }
  export interface State {

  }
}
